<template>
  <mega-menu :menuList="menuList" />
</template>

<script>
import { MegaMenu } from "../";

export default {
  name: "mega-menu-web-component",
  components: {
    MegaMenu,
  },
  data() {
    return {
      menuList: new Promise(function (resolve) {
        setTimeout(
          () =>
            resolve([
              {
                APP_ID: "administration",
                APP_NAME: "Administration",
                CLS_ICON: "icon-7",
                SEQ: 1,
                ROUTE: "app/Administration",
                ONLOAD: "ifwk.onLoadSTDApp",
                DESCRIPTION: "Administration",
                APP_PAGE: "Framewrk/Administration.html",
              },
              {
                APP_ID: "operations",
                APP_NAME: "Operations",
                CLS_ICON: "icon-3",
                SEQ: 2,
                ROUTE: "app/Operations",
                ONLOAD: "ifwk.onLoadSTDApp",
                DESCRIPTION: "Operations",
                APP_PAGE: "Framewrk/Operations.html",
              },
              {
                APP_ID: "clientmanagement",
                APP_NAME: "Client Management",
                CLS_ICON: "icon-2",
                SEQ: 3,
                ROUTE: "app/Client Management",
                ONLOAD: "ifwk.onLoadSTDApp",
                DESCRIPTION: "Client Management",
                APP_PAGE: "Framewrk/ClientManagement.html",
              },
              {
                APP_ID: "investorservices",
                APP_NAME: "Investor Services",
                CLS_ICON: "icon-4",
                SEQ: 4,
                ROUTE: "app/Investor Services",
                ONLOAD: "ifwk.onLoadSTDApp",
                DESCRIPTION: "Investor Services",
                APP_PAGE: "Framewrk/InvestorServices.html",
              },
              {
                APP_ID: "ebs",
                APP_NAME: "EBS",
                CLS_ICON: "icon-5",
                SEQ: 5,
                ROUTE: "app/EBS",
                ONLOAD: "ifwk.onLoadSTDApp",
                DESCRIPTION: "EBS",
                APP_PAGE: "Framewrk/EBS.html",
              },
              {
                APP_ID: "midoffice",
                APP_NAME: "Mid Office",
                CLS_ICON: "icon-8",
                SEQ: 6,
                ROUTE: "app/Mid Office",
                ONLOAD: "ifwk.onLoadSTDApp",
                DESCRIPTION: "Mid Office",
                APP_PAGE: "Framewrk/MidOffice.html",
              },
              {
                APP_ID: "fundmanagement",
                APP_NAME: "Fund Management",
                CLS_ICON: "icon-9",
                SEQ: 7,
                ROUTE: "app/Fund Management",
                ONLOAD: "ifwk.onLoadSTDApp",
                DESCRIPTION: "Fund Management",
                APP_PAGE: "Framewrk/FundManagement.html",
              },
              {
                APP_ID: "rmoneview",
                APP_NAME: "RM Oneview",
                CLS_ICON: "icon-10",
                SEQ: 8,
                ROUTE: "app/RM Oneview",
                ONLOAD: null,
                DESCRIPTION: "RM Oneview",
                APP_PAGE: "oneview/rm/dist/index.html",
              },
              {
                APP_ID: "customeroneview",
                APP_NAME: "Customer Oneview",
                CLS_ICON: "icon-11",
                SEQ: 9,
                ROUTE: "app/Customer Oneview",
                ONLOAD: null,
                DESCRIPTION: "Customer Oneview",
                APP_PAGE: "oneview/customer/dist/index.html",
              },
              {
                APP_ID: "tradersdesk",
                APP_NAME: "Traders Desk",
                CLS_ICON: "icon-4",
                SEQ: 10,
                ROUTE: "app/Traders Desk",
                ONLOAD: null,
                DESCRIPTION: "Traders Desk",
                APP_PAGE: "OMS/dist/index.html",
              },
              {
                APP_ID: "exception",
                APP_NAME: "Exception",
                CLS_ICON: "icon-13",
                SEQ: 11,
                ROUTE: "app/Exception View",
                ONLOAD: "ifwk.onLoadSTDApp",
                DESCRIPTION: "Exception Log",
                APP_PAGE: "oneview/exception/dist/index.html",
              },
              {
                APP_ID: "npa",
                APP_NAME: "NPA",
                CLS_ICON: "icon-17",
                SEQ: 11,
                ROUTE: "oneview/npa/dist/index.html#/",
                ONLOAD: "ifwk.onLoadSTDApp",
                DESCRIPTION: "NPA",
                APP_PAGE: "oneview/npa/dist/index.html#/",
              },
              {
                APP_ID: "riskmanagement",
                APP_NAME: "Risk Management",
                CLS_ICON: "icon-15",
                SEQ: 12,
                ROUTE: "app/Risk Management",
                ONLOAD: "ifwk.onLoadSTDApp",
                DESCRIPTION: "Risk Management",
                APP_PAGE: "oneview/riskmanagement/dist/index.html",
              },
              {
                APP_ID: "jobcenternodered",
                APP_NAME: "Job Center NodeRed",
                CLS_ICON: "icon-16",
                SEQ: 13,
                ROUTE: "Framewrk/jcnrredirect.html",
                ONLOAD: null,
                DESCRIPTION: "Job Center NodeRed",
                APP_PAGE: "Framewrk/jcnrredirect.html",
              },
              {
                APP_ID: "custom_dashboard",
                APP_NAME: "Custom Dashboard",
                CLS_ICON: "icon-18",
                SEQ: 14,
                ROUTE: "app/Custom Dashoard",
                ONLOAD: null,
                DESCRIPTION: "Custom Dashoard",
                APP_PAGE: "oneview/custom-dashboard/dist/index.html",
              },
              {
                APP_ID: "fund_registry",
                APP_NAME: "Fund Registry",
                CLS_ICON: "icon-12",
                SEQ: 15,
                ROUTE: "app/Fund Registry",
                ONLOAD: null,
                DESCRIPTION: "Fund Registry",
                APP_PAGE: "oneview/fund-registry/dist/index.html",
              },
            ]),
          8000
        );
      }),
    };
  },
};
</script>